import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function RegisterThaid() {

  const navigate = useNavigate()

  useEffect(() => {
    getParameter()
  }, [])

  const getParameter = () => {
    let refreshToken = new URLSearchParams(window.location.search).get('refresh_token')
    let accessToken = new URLSearchParams(window.location.search).get('access_token')

    console.log(accessToken)
    console.log(refreshToken)

    navigate('/register')

  }

  return (
    <div>

    </div>
  )
}

export default RegisterThaid
